import React, { ReactNode, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Box } from '@brand/components';

import {
  Footer,
  // InfoBanner,
  MenuDesktop,
  MenuMobile,
} from '@hoa/organisms';

import { useTranslation } from '@hoa/hooks';

import { AlternativeLinkType } from '@hoa/types';

import { saveMarketingData } from '../../helpers/getQueryVariable';

interface Props {
  children: ReactNode;
  hasInfoBanner?: boolean;
  hasHeader?: boolean;
  hasFooter?: `none` | `small`;
  hasCta?: boolean;
  alternativeLinks?: AlternativeLinkType[];
  isMenuSticky?: boolean;
}

export const Layout = ({
  hasHeader = true,
  isMenuSticky = true,
  ...props
}: Props): JSX.Element => {
  const { locale } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const router = useRouter();

  useEffect(() => {
    router.events.on(`routeChangeStart`, () => {
      setIsOpen(false);
    });
    return () => {
      setIsOpen(false);
    };
  }, []);

  useEffect(() => {
    const html = document.querySelector(`html`);
    if (html) html.lang = locale;
  }, [locale]);

  useEffect(() => {
    saveMarketingData();
  }, []);

  const renderHeader = () => {
    if (hasHeader) {
      return (
        <>
          {isOpen && (
            <MenuMobile alternativeLinks={props.alternativeLinks || []} />
          )}
          <MenuDesktop
            alternativeLinks={props.alternativeLinks}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            isSticky={isMenuSticky}
            hasCta={props.hasCta}
          />
        </>
      );
    }

    return <></>;
  };

  const renderFooter = () => {
    switch (props.hasFooter) {
      case `none`:
        return <></>;
      default:
        return <Footer />;
    }
  };

  return (
    <Box as="section">
      {/* <InfoBanner isVisible={props.hasInfoBanner || false} /> */}
      {renderHeader()}
      <main role="main">{props.children}</main>
      {renderFooter()}
    </Box>
  );
};
